import StoreModule from "../core/StoreModule";
import { WizardMaskState } from "./state";

class WizardMaskStore extends StoreModule<WizardMaskState> {
  protected state: WizardMaskState = {
    wizardMask: null,
  };

  get wizardMask() {
    return this.state.wizardMask;
  }

  set wizardMask(val: WizardMaskState["wizardMask"]) {
    this.setState({ wizardMask: val });
  }
}

export const $wizardMask = StoreModule.singleton(WizardMaskStore);
